var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEditIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 26,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 26,
  fill: "#DBDBDB",
  rx: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.7,
  d: "M8 20h1.098L19.796 9.302l-1.098-1.098L8 18.902zm-1 1v-2.52l13.875-13.9 2.54 2.563L9.52 21zM19.238 8.762l-.54-.558 1.098 1.098z"
})));
export { SvgEditIcon as ReactComponent };
export default __webpack_public_path__ + "d5443ac994ec5258ff89b16df2917a09.svg";